export const SET_COLLAPSE = 'navBar/setCollapse';
export const SET_TITLE = 'navBar/setTitle';